import { TFunction } from "i18next";

/**
 * Formats a relative day offset into a human-readable string.
 * @param days - The day offset (e.g., -10 = 10 days ago, 5 = in 5 days, 0 = today)
 * @param t - i18next translation function
 * @returns Formatted string like "10 days ago", "in 5 days", or "today"
 */
export const formatRelativeDays = (days: number, t: TFunction): string => {
	if (days === 0) {
		return t("contacts.smartList.relativeToday");
	}

	if (days < 0) {
		return t("contacts.smartList.relativeDaysAgo", { count: Math.abs(days) });
	}

	return t("contacts.smartList.relativeDaysFromNow", { count: days });
};

/**
 * Strips relative date fields from a filter entry value object.
 * Used before sending filter data to the backend so it recalculates fresh offsets.
 */
export const stripRelativeDateFields = <T extends Record<string, unknown>>(
	entry: T
): Omit<T, "dateMode" | "relativeDays" | "relativeDaysFrom" | "relativeDaysTill"> => {
	const { dateMode, relativeDays, relativeDaysFrom, relativeDaysTill, ...rest } = entry;

	return rest as Omit<T, "dateMode" | "relativeDays" | "relativeDaysFrom" | "relativeDaysTill">;
};
